<template>
  <div style="height: calc(100vh - 12vh);padding:0 1vw">
    <div class="breadcrumb title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>采购中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="search">
        <el-form :inline="true" style="text-align: left;">
          <el-form-item label="订单名称：">
            <el-input v-model="search.orderName" placeholder="请输入"></el-input>
          </el-form-item>
          <!-- <el-form-item label="品牌：">
            <el-input v-model="search.brand" placeholder="请输入"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="select">查询</el-button>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="primary" @click="toPurchaseRequest">采购申请</el-button>
          </el-form-item>
        </el-form>
        
      </div>

      <el-table :data="tableData" border height="67vh" style="width: 100%">
        <el-table-column label="序号" type="index" :index="indexMethod" width="80">
        </el-table-column>
        <el-table-column prop="orderName" label="订单名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.orderName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="申请人">
          <template slot-scope="scope">
            <span>{{ scope.row.createBy }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="申请时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待提交</span>
            <span v-if="scope.row.status == 1" style="color: #FDCE40;">等待审核</span>
            <span v-if="scope.row.status == 2" style="color: green;">审核通过</span>
            <span v-if="scope.row.status == 3" style="color: #FF3535;">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderRemark" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.orderRemark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="审核流程">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="see(scope.row)">查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="commit(scope.row)" :disabled="scope.row.status != '0'" style="font-size: 0.6vh;">提交
            </el-button>
            <!-- <el-button size="mini" type="danger" @click="deleteList(scope.row)"
              v-if="scope.row.status == '1'">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <el-dialog title="审批流程" :visible.sync="lookDialog" width="45%">

        <div class="step">
          <div class="number">
            <div class="step-one">1</div>
            <div class="line"></div>
            <div class="step-two">2</div>
          </div>
          <div class="detail">
            <div style="text-align: left" >
              <div>发起人：{{ flowList1.createBy }}</div>
              <div style="margin: 2vh 0;">发起时间：{{ flowList1.createDate }}</div>
            </div>
            <div style="margin-left: -2vw;text-align: left;">
              <div>审核人：{{ flowList2.createBy }}</div>
              <div style="margin: 2vh 0;">审核时间：{{ flowList2.createDate }}</div>
              <div style="margin: 2vh 0;">审核状态：
                <span v-if="flowList2.status == 2" style="color: green;">同意</span>
                <span v-if="flowList2.status == 3" style="color: red;">不同意</span>
              </div>
              <div>备注：<el-input type="textarea" style="margin-top: 1vh;" v-model="textarea"></el-input></div>
            </div>
          </div>
          <!-- <div class="detail" v-else>
            <div style="text-align: left">
              <div>处理人：</div>
              <div style="margin: 2vh 0;">处理时间：</div>
              <div>处理意见：</div>
            </div>
            <div>
              <div>处理人：</div>
              <div style="margin: 2vh 0;">处理时间：</div>
              <div>处理意见：</div>
            </div>
          </div> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import util from '../../../untils/util'
  import myHttp from '../../../untils/port'
  export default {
    data() {
      return {
        lookDialog: false,
        pageNum: 1,
        pageSize: 10,
        search: {
          orderName: ''
        },
        tableData: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
        flowList1: [],
        flowList2: [],
        textarea: ''
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      //查询
      select() {
        this.pageNum = 1
        this.pageSize = 10
        this.getData()
      },
      getData() {
        myHttp
          .myPublishList({
            projectId: util.session.get('groupId'),
            orderName: this.search.orderName,
            orderType: 'cc_sp',
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          })
          .then((resp) => {
            console.log(resp)
            if (resp.data.code == '200') {
              this.tableData = resp.data.data.list
              this.total = resp.data.data.total
            }
          })
      },
      //提交
      commit(row) {
        myHttp.submitOrder({
          id: row.id
        }).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.$message.success('提交成功')
            this.getData()
          }
        })
      },
      //  删除
      deleteList(row) {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            myHttp
              .DeleteMapping({
                id: row.id
              })
              .then((resp) => {
                console.log(resp)
                if (resp.data.code == '200') {
                  this.$message.success('删除成功')
                  this.getData()
                } else {
                  this.$message.error(resp.data.msg)
                }
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      },
      toPurchaseRequest(){
        this.$router.push({
          path: '/purchaseRequest'
        })
      },
      see(row) {
        this.lookDialog = true
        this.textarea = ''
        myHttp.findPlannedPurchaseRecord({
          plannedPurchaseId: row.id
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            this.flowList1 = resp.data.data[0] || []
            this.flowList2 = resp.data.data[1] || []
            this.textarea = resp.data.data[1].remark || '-------------'
          }
        })
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + 1 + index
      },
      handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      this.getData()
    },
    },
  }
</script>

<style scoped>
  @import '../../../assets/css/common.css';

  .container {
    height: 96%;
    background-color: #fff;
    padding: 0 1vw;
    overflow: hidden;
  }

  .search {
    margin: 2vh 0;
  }

  .container>>>.el-dialog__header {
    text-align: left;
    font-weight: 900;
  }

  .step {
    width: 90%;
    margin: 0 auto;
  }

  .number {
    display: flex;
    width: 70%;
    margin: 0 auto;
    align-items: center;
  }

  .step-one,
  .step-two {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #3F63FC;
    color: #fff;
    font-size: 30px;
    line-height: 80px;
  }

  .line {
    width: 70%;
    height: 2px;
    border-bottom: 1px dashed #3F63FC;
  }

  .detail {
    display: flex;
    justify-content: space-around;
    margin-top: 5vh;
    padding-bottom: 15vh;
  }
  .el-button--mini, .el-button--mini.is-round{
    padding: 4px 15px;
  }
</style>